
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { Badge } from '../Badge/Badge'

export const HorizontalActionSelector = ({ items, iconClassOpen, iconClassClose, text, disabled, className }) => {
  const [open, setOpen] = useState(false)

  const classContainer = classNames(className, 'm-right-thin', {
    'textlink-highlight': !disabled && !open,
    'text-light': disabled || open
  })

  const classesIcon = classNames('m-right-thin', {
    [iconClassOpen]: !open,
    [iconClassClose]: open
  })

  function onItemClick (item) {
    setOpen(false)
    if (typeof item.onClick === 'function') {
      item.onClick(item.data)
    }
  }

  return (
    <>
      {!disabled &&
      <a className={classContainer} onClick={() => setOpen(!open)}>
        <i className={classesIcon} />
        {text}
      </a>
      }
      {disabled &&
      <span className={classContainer} >
        <i className={classesIcon} />
        {text}
      </span>
      }
      {open &&
      items.map((item, key) =>
        (<Badge key={key} size='lg' {...item} onClick={() => onItemClick(item)} />)
      )
      }
    </>
  )
}

HorizontalActionSelector.defaultProps = {
  disabled: false
}

HorizontalActionSelector.propTypes = {
  text: PropTypes.string,
  callback: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  iconClassOpen: PropTypes.string,
  iconClassClose: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    command: PropTypes.string,
    type: PropTypes.string,
    active: PropTypes.bool,
    classIcon: PropTypes.string,
    className: PropTypes.string
  }))

}
